import type {
  GeneratedReleaseNotes,
  GenerateReleaseNotesRequest,
} from "@insights/contracts";
import { api } from "../api-client";

export async function generateReleaseNotes(
  workspaceId: string,
  selection: GenerateReleaseNotesRequest,
) {
  try {
    return await api<GeneratedReleaseNotes>(
      `/${workspaceId}/builds/release-notes/generate`,
      {
        method: "POST",
        body: JSON.stringify(selection),
      },
    );
  } catch (error) {
    if (!(error instanceof Error)) {
      throw error;
    }
    let problem: unknown;
    try {
      problem = JSON.parse(error.message);
    } catch {
      throw error;
    }
    if (
      problem &&
      typeof problem === "object" &&
      "title" in problem &&
      typeof problem.title === "string"
    ) {
      throw new Error(problem.title);
    }
    throw error;
  }
}
